import ldClientWrapper from "./launch-darkly-client";

export default {
    install(Vue, options) {
        ldClientWrapper.setIsMobile(options.isMobile);
        ldClientWrapper.initialize();
        Vue.prototype.$ldClient = ldClientWrapper;

        window.addEventListener('beforeunload', (e) => {
            ldClientWrapper.close();
        });
    },
};
